module.exports = __webpack_public_path__ + "static/EnmTX_BosMattias_L_B_cl-285cfb448fe5036f54272e7ac1c6bbbc.gif";